module.exports = __webpack_public_path__ + "static/img/diyimmove13.9afcbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/diyimmove13.png
// module id = 3Xpo
// module chunks = 5